import { render } from "./Balado.vue?vue&type=template&id=9cfa99e2"
import script from "./Balado.vue?vue&type=script&lang=js"
export * from "./Balado.vue?vue&type=script&lang=js"
script.render = render

export default script